import {Chip} from "@mui/material";
import React from "react";
import {useTenantOptional} from "../tenant";

export function TenantIndicator() {
	const tenant = useTenantOptional();

	if (!tenant) {
		return null;
	}

	return (
		<Chip
			label={tenant.name}
			size="small"
			variant="outlined"
		/>
	);
}
